<!--
 * @Author: Src
 * @Date: 2024-12-18 09:30:12
 * @LastEditTime: 2024-12-25 17:08:50
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/comments/UploadField.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div class="upload-field">
        <div v-if="fileList.length > 0">
            <div v-for="item in fileList" :key="item.id">
                <div class="upload-item">
                    <img :src="item.url" alt="">
                    <div class="upload-item-close" @click="handleRemove(item, fileList)">
                        <i class='el-icon-close'></i>
                    </div>
                </div>
            </div>
        </div>
        <el-upload v-else class="upload-demo" :action="`${BASE_URL}/tool/upload`" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
            :file-list="fileList" accept="image/*" :headers="{ AUTHORIZATION: token }" list-type="picture-card"
            :on-success="handleSuccess"  :on-error="handleError" :before-upload="beforeUpload">
            <el-button size="small" type="text">点击上传</el-button>
        </el-upload>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
@Component({})
export default class UploadField extends Vue {

    @lazyInject(UserService)
    protected userService!: UserService;

    token: any = '';

    options: any = {};

    BASE_URL = BASE_URL;

    fileList: any[] = [];
    

    handlePreview(file: any) {
        console.log(file);
        this.fileList = [];
    }


    @Watch('fileList')
    watchFileList(): void {
        if (this.fileList.length > 0) {
            this.$emit('change', this.fileList[0].id);
        } else {
            this.$emit('change', '');
        }
    }

    handleRemove(file: any, fileList: any) {
        console.log(fileList, 'remove');
        this.fileList = [];
    }

    beforeRemove(file: any, fileList: any) {
        console.log(file, fileList);
    }

    handleExceed(files: any, fileList: any) {
        console.log(files, fileList);
    }

    handleSuccess(response: any) {
        console.log(response, 'success');
        this.fileList = response.data;
    }
    handleError(error: any) {
        // console.log(error.indexOf('Error: '), 'error');
        // const _d = JSON.parse(error);
        this.$message.error(error);        
        // console.log(typeof _d, _d, 'error');
    }

    beforeUpload(file: any) {
        console.log(file, 'beforeUpload');
    }
    mounted() {
        // this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
        this.token = this.userService.currentUser()?.token;
        console.log(this.token);
    }
}
</script>

<style lang="scss" scoped>
.upload-field {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 150px;
    height: 150px;
    overflow: hidden;
    img {
        width: 150px;
        height: 150px;
    }

    .upload-item {
        position: relative;

        .upload-item-close {
            position: absolute;
            top: 0;
            right: 0;
        }
    }
}
</style>
